export default __webpack_public_path__ + "static/media/ser_prv_2.5db0e74d.png";